import {
  faEnvelope,
  faInfo,
  faKey,
  faUser,
  faPhone,
  faUsers,
  faVenusMars,
  faComment,
  faLanguage,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useRef } from "react";
import { Tooltip, Overlay } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import ConsentModal from "../common/ConsentModal";
import {
  registerUser,
  sendOTP,
  updateUser,
  verifyOTP,
  loginUser,
} from "../../services/AdminServices";
import Address from "../common/Address";
import FooterPanel from "../common/FooterPanel";
import MenuBar from "../common/MenuPanel";
import {
  GENDER_OPTIONS,
  REGIONS,
  LANGUAGES,
  COUNTRY_OF_ORIGIN_OPTIONS,
} from "../common/Constants";
import UtilMethods from "../../util/UtilMethods";
import { FaInfoCircle } from "react-icons/fa";

//import "bootstrap-select/dist/css/bootstrap-select.min.css";
//import "bootstrap-select/dist/js/bootstrap-select.min.js";

const SignUpPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectID = queryParams.get("redirectID");
  //("SignUpPage redirectID", redirectID);
  const { user } = useAuth();
  const { login } = useAuth();
  const userData = user?.user || user;
  const isGuest = user?.userType === "G";
  const [showConsentModal, setShowConsentModal] = useState(false); // Modal visibility state
  const [consentType, setConsentType] = useState("sign_in"); // Default consent type
  const [formData, setFormData] = useState({
    userID: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "", // New field for city
    state: "", // New field for state
    zip: "", // New field for zip
    country: "", // New field for country
    region: "",
    userType: "U",
    password: "",
    cpassword: "",
    gender: "",
    age: "",
    consentToUseData: false,
    subscribeNewsletter: false,
    lang: "",
  });

  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [otpLoading, setOTPLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [otpSent, setOTPSent] = useState(false);
  const [otpVerified, setOTPVerified] = useState(false);
  const [otp, setOTP] = useState("");
  const [resendCooldown, setResendCooldown] = useState(0); // Cooldown state for resend OTP
  const navigate = useNavigate();
  // State for Change Password mode
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [showNewsletterTooltip, setShowNewsletterTooltip] = useState(false);
  const newsletterTooltipRef = useRef(null);

  useEffect(() => {
    //console.log("SignUpPage useEffect userData", userData);
    if (userData) {
      setFormData({
        userID: userData.userID || "",
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        email: userData.email || "",
        phone: userData.phone || "",
        address: userData.address || "",
        city: userData.city || "",
        state: userData.state || "",
        country: userData.country || "",
        zip: userData.zip || "",
        region: userData.region || "US",
        userType: userData.userType || "U",
        remarks: userData.remarks || "",
        password: userData.password || "",
        cpassword: userData.password || "",
        gender: userData.gender || "",
        age: userData.age || "",
        consentToUseData: userData?.consentToUseData ?? false,
        subscribeNewsletter: userData?.subscribeNewsletter ?? false,
        lang: userData.lang || "",
      });
    }
  }, [userData]);

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(
        () => setResendCooldown(resendCooldown - 1),
        1000,
      );
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        newsletterTooltipRef.current &&
        !newsletterTooltipRef.current.contains(event.target)
      ) {
        setShowNewsletterTooltip(false);
      }
    };

    if (showNewsletterTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNewsletterTooltip]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateField(name, value);
  };

  const validateForm = () => {
    const errors = {};
    console.log("validateForm errors", errors);
    if (!formData.firstName) errors.firstName = "First Name is required";
    if (!formData.lastName) errors.lastName = "Last Name is required";
    if (!formData.email) errors.email = "Email is required";
    if (!formData.phone) errors.phone = "Phone is required";
    if (!formData.address) errors.address = "Address is required";
    if (!formData.city) errors.city = "City is required"; // Validation for city
    if (!formData.state) errors.state = "State is required"; // Validation for state
    if (!formData.zip) errors.zip = "Zip code is required"; // Validation for zip
    if (!formData.country) errors.country = "Country is required"; // Validation for country
    if (!formData.gender) errors.gender = "Gender is required";
    if (!formData.age) errors.age = "Age is required";
    if (!formData.region) errors.region = "Region is required";
    if (!formData.age || isNaN(Number(formData.age)) || formData.age < 13) {
      errors.age = "Age must be greater than or equal to 13";
    }
    if (!formData.age || isNaN(Number(formData.age)) || formData.age > 100) {
      errors.age = "Age must be less than or equal to 100";
    }
    if (isChangingPassword) {
      if (!formData.password && !user) errors.password = "Password is required";
      if (formData.password !== formData.cpassword)
        errors.cpassword = "Passwords do not match";
      const check = UtilMethods.validatePassword(formData.password);
      if (check !== "Y") {
        errors.password = check;
      }
    }
    if (!formData.consentToUseData)
      errors.consentToUseData = "Consent is required";
    setErrors(errors);
    console.log("validateForm errors", errors);
    return Object.keys(errors).length === 0;
  };
  // Function to handle the link click and show the modal
  const handleShowConsentModal = () => {
    setShowConsentModal(true); // Show the modal
  };

  // Function to close the modal
  const handleCloseConsentModal = () => {
    setShowConsentModal(false); // Hide the modal
  };

  const handleCancelClick = () => {
    navigate("/"); // Redirect to home page
  };
  // Handle check button change for consent selection
  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const validateOTPForm = () => {
    const errors = {};

    if (!formData.email || !UtilMethods.validateEmail(formData.email))
      errors.email = "Valid Email is required";
    if (!formData.phone || !UtilMethods.validatePhone(formData.phone))
      errors.phone = "Valid Phone is required";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSendOTP = async (e) => {
    e.preventDefault();
    if (!validateOTPForm()) {
      showAlert("Please fill the data before resending OTP.", "danger");
    } else if (resendCooldown === 0 && validateOTPForm()) {
      setOTPLoading(true);
      try {
        //console.log("handleSendOTP formData", formData);
        await sendOTP(formData.email, formData.phone, null, null);
        setOTPSent(true);
        setResendCooldown(30); // 30 seconds cooldown
        showAlert("OTP sent to your Phone.", "success");
      } catch (error) {
        console.error("Error sending OTP", error);
        showAlert(error.message, "danger");
      } finally {
        setOTPLoading(false);
      }
    } else {
      showAlert("Please wait before resending OTP.", "danger");
    }
  };
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "email":
        if (!value) {
          error = "Email is required.";
        } else if (!UtilMethods.validateEmail(value)) {
          error = "Invalid email format.";
        }
        break;

      case "password":
        if (!value) {
          error = "Password is required.";
        } else {
          const check = UtilMethods.validatePassword(value);
          if (check !== "Y") {
            error = check;
          }
        }
        break;
      case "cpassword":
        if (value !== formData.password) {
          error = "Passwords do not match.";
        }
        break;

      case "firstName":
        if (!value.trim()) {
          error = "First name is required.";
        }
        break;

      case "phone":
        if (!value) {
          error = "Phone number is required.";
        } else if (!UtilMethods.validatePhone(value)) {
          error = "Invalid phone number format.Include country code.";
        }
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    //setLoading(true);

    if (!otpVerified) {
      try {
        const response = await verifyOTP(
          otp,
          formData.email,
          formData.phone,
          "REGISTRATION",
          null,
        );
        const isVerified =
          response.data.status === "approved" ? true : response.data.status;
        console.log("verifyOTP isVerified", isVerified);
        if (isVerified) {
          setOTPVerified(true);
          showAlert("OTP verified successfully.", "success");
        } else {
          showAlert("Invalid OTP. Please try again.", "danger");
          setLoading(false);
          return;
        }
      } catch (error) {
        showAlert("Error verifying OTP. Please try again.", "danger");
        setLoading(false);
        return;
      }
    } else {
      showAlert("OTP verified successfully.", "success");
    }
  };
  const handleLogin = async (email, password) => {
    setLoading(true);
    try {
      const response = await loginUser(email, password);
      const userData = response.user;
      const token = response.token;

      if (!userData || !token) {
        return false;
      }

      console.log("User data:", userData.id);
      // Update AuthContext
      await login({ userData, token });
      return true;
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
    return false;
  };
  const handleSubmit = async (e) => {
    console.log("handleSubmit otpVerified", otpVerified);
    console.log("handleSubmit isChangingPassword", isChangingPassword);
    console.log(
      "handleSubmit isChangingPassword",
      otpVerified || isChangingPassword,
    );
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);

      if (otpVerified || isChangingPassword) {
        //console.log("handleSubmit formData", formData);
        try {
          ///console.log("handleSubmit formData", formData);
          const response = user
            ? await updateUser(formData)
            : await registerUser(formData);
          showAlert("Success!", "success");
          setEditMode(null);
          setOTPVerified(false);
          console.log("handleSubmit redirectID", redirectID);
          if (!user) {
            if (redirectID) {
              const isLoggedIn = await handleLogin(
                formData.email,
                formData.password,
              );
              console.log("################ isLoggedIn # ", isLoggedIn);
              if (isLoggedIn) {
                navigate(`/retreat-registration?id=${redirectID}`);
              }
            } else {
              navigate("/login"); // Redirect to login page after registration
              // Reset form after submission
              setFormData({
                userID: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                address: "",
                city: "", // Reset city
                state: "", // Reset state
                zip: "", // Reset zip
                country: "", // Reset country
                region: "",
                userType: "U",
                password: "",
                cpassword: "",
                gender: "",
                age: "",
                consentToUseData: false,
                subscribeNewsletter: false,
                lang: "",
              });
            }
          } else {
            setIsChangingPassword(false);
          }
        } catch (error) {
          showAlert(error.message, "danger");
        } finally {
          setLoading(false);
        }
      }
      //console.log("handleSubmit formData", formData);
    } else {
      const firstError = Object.values(errors).find((error) => error);
      if (firstError) {
        console.log("handleSubmit firstError", firstError);
        showAlert(firstError, "danger");
      } else {
        console.log("handleSubmit errors", errors);
        showAlert("Please fill the data before submitting.", "danger");
      }
    }
  };

  const showAlert = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setTimeout(() => {
      setAlertMessage("");
      setAlertType("");
    }, 5000);
  };

  const handleEditClick = () => {
    setEditMode(true);
    setOTPVerified(true);
  };

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      {/* Title Section with Overlay */}

      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">
              {user ? "Your Profile Information" : "Sign Up"}
            </h1>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="banner-description">
          <p>
            <i>
              So then you are no longer strangers and sojourners, but you are
              fellow citizens with the holy ones and members of the household of
              God, built upon the foundation of the apostles and prophets, with
              Christ Jesus himself as the capstone. Through him the whole
              structure is held together and grows into a temple sacred in the
              Lord; in him you also are being built together into a dwelling
              place of God in the Spirit.
            </i>{" "}
            - Ephesians 2:19-22{" "}
          </p>
          <p> Be a member of Grace Anointing family and get updates</p>
        </div>
        {alertMessage && (
          <div className={`alert alert-${alertType}`} role="alert">
            {alertMessage}
          </div>
        )}

        {user && !editMode ? (
          <div>
            {/* User Profile Display */}
            <div className="mb-2">
              <strong>First Name:</strong> {formData.firstName}
            </div>
            <div className="mb-2">
              <strong>Last Name:</strong> {formData.lastName}
            </div>
            <div className="mb-2">
              <strong>Email:</strong> {formData.email}
            </div>
            <div className="mb-2">
              <strong>Phone:</strong> {formData.phone}
            </div>
            <div className="mb-2">
              <strong>Address:</strong> {formData.address}, {formData.city},{" "}
              {formData.state} {formData.zip}, {formData.country}
            </div>
            <div className="mb-2">
              <strong>Region:</strong> {formData.region}
            </div>
            {user && user.userType.includes("A") && (
              <>
                {formData.userType && (
                  <div className="mb-2">
                    <strong>User Type:</strong> {formData.userType}
                  </div>
                )}
                {formData.remarks && (
                  <div>
                    <strong>Remarks:</strong> {formData.remarks}
                  </div>
                )}
              </>
            )}
            {user && (
              <button
                className="btn btn-primary me-2"
                onClick={() => (editMode ? handleSubmit() : handleEditClick())}
                disabled={isGuest}
              >
                {editMode ? "Save" : "Edit"}
              </button>
            )}
            <button
              className="btn btn-primary me-2"
              onClick={() => setIsChangingPassword(!isChangingPassword)}
              disabled={isGuest}
            >
              {isChangingPassword
                ? "Cancel Change Password"
                : "Change Password"}
            </button>
            {/* cancel Button */}
            <button
              type="cancel"
              className="btn btn-primary me-2"
              onClick={handleCancelClick}
            >
              {"Cancel"}
            </button>
            {isChangingPassword && (
              <>
                <div className="mt-3 ">
                  <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="New Password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  {errors.password && (
                    <span className="text-danger">{errors.password}</span>
                  )}
                  <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Confirm Password"
                    name="cpassword"
                    value={formData.cpassword}
                    onChange={handleChange}
                    required
                  />
                  {errors.cpassword && (
                    <span className="text-danger">{errors.cpassword}</span>
                  )}
                </div>
                <div>
                  <button
                    className="btn btn-success mt-1"
                    onClick={handleSubmit}
                    disabled={isGuest}
                  >
                    Update Password
                  </button>
                </div>
              </>
            )}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form mt-4">
            {/* Form Fields */}
            <div className="row">
              <div className="col-md-6 col-12 mb-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger ms-1">*</span>
                  </span>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className={`form-control ${
                      errors.firstName ? "is-invalid" : ""
                    }`}
                  />

                  {errors.firstName && (
                    <span className="invalid-feedback">{errors.firstName}</span>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-12 mb-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger ms-1">*</span>
                  </span>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.lastName ? "is-invalid" : ""
                    }`}
                    placeholder="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  {errors.lastName && (
                    <span className="invalid-feedback">{errors.lastName}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-12 mb-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faEnvelope} />
                    <span className="text-danger ms-1">*</span>
                  </span>
                  <input
                    type="email"
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={otpVerified || (user && editMode)} // Disable if OTP is verified or editing existing user
                    required
                  />
                  {errors.email && (
                    <span className="invalid-feedback">{errors.email}</span>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-12 mb-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faPhone} />
                    <span className="text-danger ms-1">*</span>
                  </span>
                  <PhoneInput
                    className={`form-select ${
                      errors.phone ? "is-invalid" : ""
                    }`}
                    flagUrl="https://flagcdn.com/w320/{xx}.png"
                    placeholder="Phone"
                    name="phone"
                    defaultCountry="US"
                    disabled={otpVerified || (user && editMode)} // Disable if OTP is verified or editing existing user
                    value={formData.phone}
                    onChange={(phone) => setFormData({ ...formData, phone })}
                    required
                  />
                  {errors.phone && (
                    <span className="invalid-feedback">{errors.phone}</span>
                  )}
                </div>
              </div>
            </div>

            {/* OTP Verification */}
            {!otpVerified && (
              <>
                {/* OTP Input Field - Display only if OTP has been sent */}
                {otpSent && (
                  <div className="form-group mb-2 mt-1">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.otp ? "is-invalid" : ""
                      }`}
                      placeholder="OTP"
                      name="otp"
                      value={otp}
                      onChange={(e) => setOTP(e.target.value)}
                      required
                    />
                    {errors.otp && (
                      <span className="text-danger">{errors.otp}</span>
                    )}
                  </div>
                )}
                <div className="d-flex justify-content-between gap-4 mb-2">
                  <button
                    type="button"
                    className="btn btn-light flex-grow-1"
                    onClick={handleVerifyOTP}
                    disabled={loading || otpVerified || !otpSent}
                  >
                    {loading
                      ? "Verifying..."
                      : otpVerified
                        ? "Verified"
                        : "Verify OTP"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary flex-grow-1"
                    onClick={handleSendOTP}
                    disabled={otpLoading || resendCooldown > 0}
                  >
                    {otpLoading ? "Sending OTP..." : "Send OTP"}
                    {resendCooldown > 0 && ` (${resendCooldown}s)`}
                  </button>
                </div>
              </>
            )}

            <div>
              {/* Conditionally render the tooltip */}
              {!otpVerified && (
                <div className="badge-warning">
                  OTP not verified! Please verify the OTP to continue.
                </div>
              )}
              <div className="row">
                {/* Gender Field */}
                <div className="col-md-6 col-12 mb-2">
                  <div className="input-group">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon={faVenusMars} />
                      <span className="text-danger ms-1">*</span>
                    </span>
                    <select
                      className={`form-select ${
                        errors.gender ? "is-invalid" : ""
                      }`}
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      disabled={!otpVerified}
                      required
                    >
                      {GENDER_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {errors.gender && (
                      <span className="text-danger">{errors.gender}</span>
                    )}
                  </div>
                </div>
                {/* Age Field */}
                <div className="col-md-6 col-12 mb-2">
                  <div className="input-group">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon={faInfo} />
                      <span className="text-danger ms-1">*</span>
                    </span>
                    <input
                      type="number"
                      className={`form-control ${
                        errors.age ? "is-invalid" : ""
                      }`}
                      placeholder="Age"
                      disabled={!otpVerified}
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                      required
                    />
                    {errors.age && (
                      <span className="text-danger">{errors.age}</span>
                    )}
                  </div>
                </div>
              </div>
              {(!editMode || !user) && (
                <div className="row">
                  {/* Password Fields */}
                  <div className="col-md-6 col-12 mb-2">
                    <div className="input-group">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faKey} />
                        <span className="text-danger ms-1">*</span>
                      </span>
                      <input
                        type="password"
                        className={`form-control ${
                          errors.password ? "is-invalid" : ""
                        }`}
                        placeholder="Password"
                        name="password"
                        disabled={!otpVerified}
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      {errors.password && (
                        <span className="text-danger">{errors.password}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-2">
                    <div className="input-group">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faKey} />
                        <span className="text-danger ms-1">*</span>
                      </span>
                      <input
                        type="password"
                        className={`form-control ${
                          errors.cpassword ? "is-invalid" : ""
                        }`}
                        placeholder="Confirm Password"
                        name="cpassword"
                        value={formData.cpassword}
                        disabled={!otpVerified}
                        onChange={handleChange}
                        required
                      />
                      {errors.cpassword && (
                        <span className="text-danger">{errors.cpassword}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                {/* Address, City, State, Zip, Country */}
                <Address
                  formData={formData}
                  setFormData={setFormData}
                  enabled={otpVerified}
                  errors={errors}
                  colCount={2}
                  requiredFields={[
                    "address",
                    "city",
                    "state",
                    "country",
                    "zip",
                  ]}
                />
              </div>
              <div className="row">
                {user && user.userType.includes("A") && (
                  <>
                    <div className="col-md-6 col-12 mb-2">
                      <div className="input-group">
                        <span className="input-group-text">
                          <FontAwesomeIcon icon={faUser} />
                          <span className="text-danger ms-1">*</span>
                        </span>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.userType ? "is-invalid" : ""
                          }`}
                          placeholder="User Type (U - User/A-Admin)"
                          name="userType"
                          value={formData.userType}
                          onChange={handleChange}
                          required
                        />

                        {errors.userType && (
                          <span className="text-danger">{errors.userType}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                      <div className="input-group">
                        <span className="input-group-text">
                          <FontAwesomeIcon icon={faComment} />
                        </span>
                        <Overlay
                          target={document.querySelector('[name="remarks"]')}
                          show={true}
                          placement="top"
                        >
                          {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                              Enter any additional remarks here.
                            </Tooltip>
                          )}
                        </Overlay>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.remarks ? "is-invalid" : ""
                          }`}
                          placeholder="Remarks"
                          name="remarks"
                          value={formData.remarks}
                          onChange={handleChange}
                          title="Enter any additional remarks here."
                        />
                        {errors.remarks && (
                          <span className="text-danger">{errors.remarks}</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="row">
                <div className="col-md-6 col-12 mb-2">
                  <div className="input-group">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon={faUsers} />
                      <span className="text-danger ms-1">*</span>
                    </span>
                    <select
                      className={`form-control ${
                        errors.region ? "is-invalid" : ""
                      }`}
                      name="region"
                      value={formData.region}
                      onChange={handleChange}
                      disabled={!otpVerified}
                      required
                    >
                      <option value="">Select Region</option>
                      {REGIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {errors.region && (
                      <span className="text-danger">{errors.region}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-1 mt-0 form-group">
                  <div className="input-group mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="consentToUseData"
                      checked={formData.consentToUseData}
                      onChange={handleCheckChange}
                    />
                    <a
                      href="#"
                      aria-label="Consent to use data"
                      onClick={(e) => {
                        e.preventDefault();
                        setConsentType("sign_in");
                        handleShowConsentModal();
                      }}
                    >
                      <span className="text-danger ms-1">*</span>
                      <u>{" Consent to use data."}</u>
                    </a>
                    {errors.consentToUseData && (
                      <span className="text-danger">
                        {errors.consentToUseData}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="subscribeNewsletter"
                      checked={formData.subscribeNewsletter}
                      onChange={handleCheckChange}
                    />
                    <a
                      href="#"
                      aria-label="Subscribe to newsletter"
                      onClick={(e) => {
                        e.preventDefault();
                        setConsentType("newsletter");
                        handleShowConsentModal();
                      }}
                    >
                      {" "}
                      <u className="text-decoration-underline ms-2">
                        {" Subscribe Newsletter for the region"}
                      </u>
                    </a>
                    <span
                      ref={newsletterTooltipRef}
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer",
                        color: "#5b3804",
                      }}
                      onClick={() =>
                        setShowNewsletterTooltip(!showNewsletterTooltip)
                      }
                      onMouseEnter={() => setShowNewsletterTooltip(true)}
                      onMouseLeave={() => setShowNewsletterTooltip(false)}
                    >
                      <FaInfoCircle />
                    </span>
                    {errors.subscribeNewsletter && (
                      <span className="text-danger">
                        {errors.subscribeNewsletter}
                      </span>
                    )}
                  </div>
                  <Overlay
                    target={newsletterTooltipRef.current}
                    show={showNewsletterTooltip}
                    placement="top"
                  >
                    {(props) => (
                      <Tooltip id="newsletter-tooltip" {...props}>
                        You will receive newsletters and updates for your
                        region.
                      </Tooltip>
                    )}
                  </Overlay>
                </div>
              </div>

              {formData.subscribeNewsletter && (
                <div className="row mt-1">
                  <div className="col-6 mb-2">
                    <div className="input-group">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faGlobe} />
                        <span className="text-danger ms-1">*</span>
                      </span>

                      <select
                        className="form-select"
                        name="countryOfOrigin"
                        value={formData.countryOfOrigin || ""}
                        onChange={handleChange}
                      >
                        <option value="">Country of Origin</option>
                        {COUNTRY_OF_ORIGIN_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-6 mb-2">
                    <div className="input-group">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faLanguage} />
                        <span className="text-danger ms-1">*</span>
                      </span>

                      <select
                        className="form-select"
                        name="lang"
                        value={formData.lang || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select Preferred Language</option>
                        {LANGUAGES.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-between gap-4 mb-2">
              {/* Cancel Button */}
              <button
                type="button"
                className="btn btn-light flex-grow-1"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-primary flex-grow-1"
                disabled={loading || !otpVerified}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        )}
      </div>
      {/* Render the ConsentModal */}
      <ConsentModal
        show={showConsentModal}
        type={consentType}
        onCancel={handleCloseConsentModal}
      />
      <FooterPanel />
    </React.Fragment>
  );
};

export default SignUpPage;
